export default "__VITE_ASSET__DiVhGSIq__"